import React from 'react';
import './StandardCreditCardOffer.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const MinimunDeposit = ({ minimunDepositDetails }) => {
  return (
    <FlexContainer className="flex-column m-margt12">
      <FlexContainer className="cardAttributes__blockTitle">
        Minimum Deposit
      </FlexContainer>
      <FlexContainer className="text-12">{minimunDepositDetails}</FlexContainer>
    </FlexContainer>
  );
};

export default MinimunDeposit;
